<template>
  <div class="preview-color" :class="current.destroy ? 'mockup--destroy' : ''">
    <div class="preview-color__header">
      <select-color
        :colors="colors"
        :input="current.hex"
        @input="(r) => (current.hex = r)"
      />

      <div class="mockup__input">
        <label
          class="mockup__btn-icon"
          :for="`MockupPreviewColors${timestamp}`"
        >
          <icon-eye-droper />
        </label>
        <input
          type="color"
          v-show="false"
          :id="`MockupPreviewColors${timestamp}`"
          class="mockup-preview__colors-input"
          @input="(e) => $emit('addColor', e.target.value)"
        />
      </div>

      <div
        class="mockup__btn-icon"
        :class="current.destroy ? 'mockup__btn-icon--active' : ''"
        @click="current.destroy = !current.destroy"
      >
        <icon-trash />
      </div>
    </div>

    <div
      class="preview-color__image"
      :style="{ backgroundImage: `url(${current.src})` }"
    >
      <span class="preview-color__image-order">{{ current.order }}</span>
    </div>
  </div>
</template>

<script>
import SelectColor from "./select-color/SelectColor.vue";

import IconTrash from "@gocasebr/go-shared/dist/trash/Trash";
import IconEyeDroper from "@gocasebr/go-shared/dist/eye-droper/EyeDroper";

export default {
  components: { SelectColor, IconTrash, IconEyeDroper },
  props: {
    current: Object,
    colors: Array,
    timestamp: Number,
  },
  watch: {
    colors() {
      this.updateOrder();
    },
    current: {
      handler() {
        this.updateOrder();
      },
      deep: true,
    },
  },
  methods: {
    updateOrder() {
      if (!this.colors) return;
      this.current.order = this.colors.indexOf(this.current.hex);
    },
  },
  mounted() {
    this.updateOrder();
  },
};
</script>

<style lang="scss" scoped>
.preview-color {
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  flex: none;
  cursor: grab;
  padding: 6px;
  margin-bottom: 6px;
  border: 1px solid #f2f2f4;

  .preview-color__header {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 6px;
  }

  .preview-color__image {
    width: 200px;
    height: 200px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    text-shadow: 0px 0px 5px #ec8ab3;
    color: #fff;
  }
}
</style>
